/** 首板 MA 过滤周期（与后端 MA_FILTER_MAX_PERIODS 一致） */
export const MA_FILTER_PERIODS = [10, 20, 30, 40, 60, 110, 120, 160, 210, 250]

export function computeMaMaxFromStock(stock) {
  const fromField = Number(stock?.maMax)
  if (Number.isFinite(fromField) && fromField > 0) return fromField
  const vals = MA_FILTER_PERIODS.map((p) => Number(stock?.[`ma${p}`])).filter(
    (v) => Number.isFinite(v) && v > 0
  )
  return vals.length ? Math.max(...vals) : null
}

/**
 * 统一「过滤MA250」：仅按个股首板判定。
 * 首板价 × 1.1 × 1.1 > maMax，maMax = max(MA10…MA250)
 * 缺首板价或缺 maMax → 不通过。
 */
export function passesMa250Filter(stock) {
  const base = Number(stock?.firstBoardPrice ?? stock?.closePrice)
  const threshold = base * 1.1 * 1.1
  const maMax = computeMaMaxFromStock(stock)
  if (!Number.isFinite(threshold) || !Number.isFinite(maMax) || maMax <= 0) {
    return false
  }
  return threshold > maMax
}
